import {AuthPage} from "../pages/AuthPage"
import { GraphsPage } from "../pages/GraphsPage"
import { MainPage } from "../pages/MainPage"
import { ProfilePage } from "../pages/ProfilePage"
import { RegistrationPage } from "../pages/RegistrationPage"
import { SearchPage } from "../pages/SearchPage"
import { SelectionPage } from "../pages/SelectionPage"
import { SummarizationPage } from "../pages/SummarizationPage"
import {  AUTH, GRAPHS, MAIN, PROFILE, REG, SEARCH, SELECTION, SUMM } from "./consts"

export const authRoutes = [
    {
        element: <ProfilePage />,
        path: PROFILE
    },
    {
        element: <SearchPage />,
        path: SEARCH
    },
    {
        element: <SelectionPage />,
        path: SELECTION
    },
    {
        element: <GraphsPage />,
        path: GRAPHS
    },
    {
        element: <SummarizationPage />,
        path: SUMM
    }
]
export const publicRoutes = [
    {
        element: <AuthPage />,
        path: AUTH
    },
    {
        element: <RegistrationPage />,
        path: REG
    },
    {
        element: <MainPage />,
        path: MAIN
    }
]